export default{
    path: 'code',
    name: 'CodeManagementForm',
    component(){
        return import('@/components/codeManagement/codeManagementForm.vue');
    },
    children:[
        {
            path: '',
            name: 'MenuList',
            component() {
				return import('@/components/codeManagement/menu/MenuList.vue')
            }
        },
        {
            path: 'role',
            name: 'RoleList',
            component() {
				return import('@/components/codeManagement/role/RoleForm.vue')
            }
        },
        {
            path: 'common',
            name: 'CodeDivList',
            component() {
                return import('@/components/codeManagement/code/codeDivList.vue')
            }
        },
        {
            path:'common/:id',
            name:'codeDivDetailForm',
            component() {
                return import('@/components/codeManagement/code/codeDivDetail/codeDivDetailForm.vue');
            }
        },


    ],
}